import { render, staticRenderFns } from "./pricereqapprove.vue?vue&type=template&id=dac052c6&scoped=true&"
import script from "./pricereqapprove.vue?vue&type=script&lang=js&"
export * from "./pricereqapprove.vue?vue&type=script&lang=js&"
import style0 from "./pricereqapprove.vue?vue&type=style&index=0&id=dac052c6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac052c6",
  null
  
)

export default component.exports